import React from 'react';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Kontakt</h3>
          <div className="contact-item">
            <FaEnvelope />
            <span>swiderova@archibim.cz</span>
          </div>
          {/* <div className="contact-item">
            <FaPhone />
            <span>+420 123 456 789</span>
          </div> */}
          <div className="contact-item">
            <FaMapMarkerAlt />
            <span>Havířov, Česká republika</span>
          </div>
        </div>
        <div className="footer-section">
          <h3>DS - Architekt</h3>
          <p>Profesionální architektonické služby</p>
          <p>Všechny projekty jsou realizovány ve spolupráci s <a className="archibim-link" href="http://archibim.cz/" target="_blank" rel="noopener noreferrer">ArchiBIM studio s.r.o.</a></p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 DS - Architekt. Všechna práva vyhrazena.</p>
      </div>
    </footer>
  );
};

export default Footer;
